import "./App.css";
import "./global/primary.css";
import "./global/grid.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import BookDemo from "./pages/BookDemo";
import ErrorComponent from "./components/Error Component/ErrorComponent";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BookDemo />} />
        <Route path="/error" element={<ErrorComponent />} />
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
